export const ACCESS_ROUTES = [
  '/auth'
];

export const UNPROTECTED_ROUTES = [
  '/document',
  '/auth'
];

export const APP_URLS = {
  LOGIN: '/',
  DASHBOARD: '/admin',
  CARTA_PORTE: '/admin/carta-porte',
  REPORTS: '/admin/reports',
  COMPANIES: '/admin/companies',
  ADMINS: '/admin/admins',
  TEMPLATES: '/admin/templates',
  PROYECTS: '/admin/proyects',
  PRODUCTS: '/admin/products',
  INVOICES: '/admin/invoices',
  SHOPPING: '/admin/shoppings',
  STORE: '/admin/store',
  SEMINUEVOS: '/admin/seminuevos',
  PROYECT_CREATOR: '/admin/proyect/creator',
  DOCUMENTS: '/admin/documents',
  DOCUMENT_CREATOR: '/admin/document/creator',
  PROFILE: '/admin/profile',
  HISTORY: '/admin/history',
  CONFIG: '/admin/config',
  SPLITS: '/admin/splits',
  TRANSFERS: '/admin/transfers',
  SETTING: '/admin/setting',
  NOTIFICATIONS: '/admin/notifications',
  HISTORY_RESPONSABLE: '/admin/history-responsable',
  CONFIG_PETITIONS: '/admin/config-projects',
  CONFIG_PETITIONS_APPROVE: '/admin/config-projects/approve',
  CONFIG_PETITIONS_LIST: '/admin/config-petitions',
  BITACORAS: '/admin/bitacoras',
  BITACORA_NEW: '/admin/bitacoras/nueva',
  BITACORA_EDIT: '/admin/bitacoras/editar',
  BITACORA_DETAIL: '/admin/bitacoras/detalle',
  BITACORAS_CONFIG: '/admin/bitacoras-config',
  BITACORA_CONFIG_NEW: '/admin/bitacoras-config/nueva',
  BITACORA_CONFIG_EDIT: '/admin/bitacoras-config/editar',
  BITACORA_CONFIG_DETAIL: '/admin/bitacoras-config/detalle',
  GARANTIAS: '/admin/garantias',
  MY_DELIVERIES: '/admin/my-deliveries',
  HERRAMIENTAS: '/admin/herramientas',
  HERRAMIENTA_NEW: '/admin/herramientas/nueva',
  HERRAMIENTA_EDIT: '/admin/herramientas/editar',
  KIT_NEW: '/admin/herramientas/kits/nueva',
  KIT_EDIT: '/admin/herramientas/kits/editar',
  STOCK_ENTRY: '/admin/herramientas/entrada',
  HERRAMIENTAS_MOVIMIENTOS: '/admin/herramientas-movimientos',
  HERRAMIENTAS_PRESTAMOS: '/admin/herramientas-prestamos',
  HERRAMIENTAS_PRESTAMOS_NUEVA: '/admin/herramientas-prestamos/nueva',
  HERRAMIENTAS_STOCK: '/admin/herramientas-stock',
};

export const ACCESS_ROLES: Record<string, string[]> = {
  '/admin/products': ['sub', 'admin', 'almacen'],
  '/admin/store': ['sub', 'admin', 'almacen'],
  '/admin/seminuevos': [],
  '/admin/history': ['sub', 'admin', 'almacen'],
  '/admin/config': ['sub', 'admin', 'almacen'],
  '/admin/splits': ['sub', 'encargado', 'admin'],
  '/admin/setting': ['sub', 'admin', 'almacen'],
  '/admin/history-responsable': ['encargado', 'admin', 'sub'],
  '/admin/config-projects/approve': ['encargado_config_area', 'admin', 'sub'],
  '/admin/config-projects': ['encargado_config', 'encargado_config_area', 'admin', 'sub'],
  '/admin/config-petitions': ['sub', 'admin', 'almacen'],
  '/admin/bitacoras': ['sub', 'admin', 'almacen', 'encargado'],
  '/admin/bitacoras-config': ['encargado_config', 'encargado_config_area', 'admin', 'sub'],
  '/admin/garantias': ['sub', 'admin', 'almacen', 'encargado_config', 'encargado_config_area'],
  '/admin/my-deliveries': ['transportista', 'admin', 'sub'],
  '/admin/herramientas': ['sub', 'admin', 'almacen'],
};

export const STATUS_DOCUMENT = [
  {
    slug: 'COMPLETADO',
    color: '#4CAF50',
  },
  {
    slug: 'PENDIENTE',
    color: '#FB8C00',
  }
];

export const STATUS_VOBO = [
  {
    slug: 'ACEPTADO',
    color: '#4CAF50',
  },
  {
    slug: 'PENDIENTE',
    color: '#FB8C00',
  },
  {
    slug: 'RECHAZADO',
    color: 'red',
  }
];
